const Direction = Object.freeze({
  NEXT: "next",
  PREVIOUS: "previous",
})

export default Direction
